import React, { useEffect, useState } from "react";
import AddTask from "./components/Modals/AddTask";
import NewLaunchPad from "./components/NewLaunchPad";
import { MMStyles } from "../EditMenus/components/Modals/AddNewMenuModal";
import { useAppServices } from "../../../../hook/services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Native GHL "Classic" launchpad items. GHL reuses id="chat-connect" for several
// cards (chat widget, stripe, wordpress), so those carry a `buttonSelector` (their
// UNIQUE button id) that the script uses to locate the right card instead of the
// ambiguous container id.
const defaultTasks = [
  {
    type: "default",
    id: 1,
    selector: "chat-connect",
    description: "Download our app and engage with your leads on the go!",
    buttonText: "Send Link",
    imageUrl:
      "https://static.leadconnectorhq.com/1551/img/icon-android-ios.BaX5xvHy.png",
    tagline: "",
  },
  {
    type: "default",
    id: 2,
    selector: "gmb-connect",
    description:
      "Manage your Google Business Profile within your CRM! Monitor and reply to your Google Business Profile reviews.",
    buttonText: "Connect",
    imageUrl: "https://static.leadconnectorhq.com/img/gmb.90d0fb06.svg",
  },
  {
    type: "default",
    id: 3,
    selector: "fb-connect",
    description:
      "Connect directly with prospects and customers via Messenger in Conversation and sync your Facebook leads with our CRM.",
    buttonText: "Connect",
    imageUrl: "https://static.leadconnectorhq.com/img/icon-facebook.0fedcae1.svg",
  },
  {
    type: "default",
    id: 4,
    selector: "chat-connect",
    buttonSelector: "launchpad-chatwidget-connect",
    description: "Generate leads from your website by connecting webchat widget.",
    buttonText: "Connect",
    imageUrl:
      "https://static.leadconnectorhq.com/img/icon-chat-widget-integration.ee9ce5e8.svg",
    tagline:
      "The chat widget status check may not be accurate, if the widget code is not directly embedded in the website",
  },
  {
    type: "default",
    id: 5,
    selector: "whatsapp-connect",
    description: "Integrate WhatsApp",
    buttonText: "Connect",
    // WhatsApp's native icon is an inline <svg> (no URL), so we use a self-contained
    // data-URI here purely for the admin list display.
    imageUrl:
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cpath fill='%2325D366' d='M16 0C7.2 0 0 7.2 0 16c0 2.8.8 5.5 2.2 7.9L0 32l8.3-2.2C10.6 31.2 13.2 32 16 32c8.8 0 16-7.2 16-16S24.8 0 16 0z'/%3E%3Cpath fill='%23fff' d='M11.9 8.8c-.3-.6-.5-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.3 2.4 3.7 5.9 5.1 2.9 1.2 3.5 1 4.1.9.6-.1 2-.8 2.3-1.6.3-.8.3-1.4.2-1.6-.1-.1-.3-.2-.7-.4-.4-.2-2-1-2.3-1.1-.3-.1-.5-.2-.8.2-.2.3-.8 1.1-1 1.3-.2.2-.4.2-.7.1-.4-.2-1.5-.6-2.8-1.7-1-1-1.7-2.1-1.9-2.5-.2-.3 0-.5.1-.7.2-.2.4-.4.5-.6.2-.2.2-.3.4-.5.1-.2.1-.4 0-.6-.1-.1-.8-1.9-1.1-2.6z'/%3E%3C/svg%3E",
    tagline:
      "Connect your WhatsApp Business account for instant, real-time communication and reach out to your customers on their preferred platform",
  },
  {
    type: "default",
    id: 6,
    selector: "chat-connect",
    buttonSelector: "launchpad-stripe-connect",
    description: "Connect your Stripe account to start accepting payments.",
    buttonText: "Connect",
    imageUrl: "https://static.leadconnectorhq.com/img/stripe_logo.5a4dee84.png",
    tagline:
      "Existing stripe API integration will continue to work, but it is advised to use Stripe Connect for more security",
  },
  {
    type: "default",
    id: 7,
    selector: "chat-connect",
    buttonSelector: "launchpad-wordpress",
    description: "Move your WordPress site to our blazing fast and affordable hosting",
    buttonText: "Connect",
    imageUrl: "https://static.leadconnectorhq.com/pmd/img/icon-wordpress-logo.jpg",
  },
  {
    type: "default",
    id: 8,
    selector: "invite-user",
    description: "Quickly add one or more team members.",
    buttonText: "Add",
    imageUrl: "https://static.leadconnectorhq.com/img/icon-add-member.a0b41d16.svg",
    tagline:
      "The new user(s) will have the same permissions like yours except the ability to add new users.",
  },
];

const LaunchPad = () => {
  const AppService = useAppServices();
  const { companyId, type, customizationId } = useParams();
  const [tasks, setTasks] = useState(defaultTasks);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(true);
  const [launchpadType, setLaunchpadType] = useState("old");
  const [pendingType, setPendingType] = useState(null); // launchpad-switch confirm
  const handler =
    type === "agency" || type === "location"
      ? AppService.sidenav_customizer_main_level
      : type === "group"
      ? AppService.sidenav_customizer_custom_level
      : AppService.sidenav_customizer_saas_level;

  let query =
    type === "location" || type === "agency"
      ? `companyId=${companyId}&type=${type}`
      : `_id=${customizationId}`;

  const getData = async () => {
    const { response } = await handler.filter({
      query: query,
    });
    if (response) {
      if (response?.data?.launchpads?.length) {
        setTasks(response?.data?.launchpads);
      }
      if (response?.data?.launchpad_type) {
        setLaunchpadType(response.data.launchpad_type);
      }
      setData(response.data);
      setLoader(false);
    } else {
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleResetDefault = async () => {
    const launchpads = defaultTasks;
    const payload = {
      launchpads,
      companyId,
      ...(data?._id && { _id: data._id }),
    };

    const { response } = await handler[data?._id ? "update" : "create"]({
      payload,
    });

    if (response) {
      getData();
      toast.success("Tasks reset successfully!");
    } else {
      toast.error("Error resetting tasks");
    }
  };

  // Open the confirmation modal (actual switch happens in confirmSwitch).
  const handleToggleType = (newType) => {
    if (newType === launchpadType) return;
    setPendingType(newType);
  };

  const confirmSwitch = async () => {
    const newType = pendingType;
    setPendingType(null);
    if (!newType) return;

    // Reset settings on switch: Classic falls back to the built-in defaults,
    // Setup Guide starts from an empty configuration.
    const resetTasks = newType === "old" ? defaultTasks : [];

    const payload = {
      launchpad_type: newType,
      launchpads: resetTasks,
      companyId,
      type,
      ...(data?._id && { _id: data._id }),
    };

    const { response } = await handler[data?._id ? "update" : "create"]({
      payload,
    });

    if (response) {
      setLaunchpadType(newType);
      setTasks(resetTasks);
      setData(response.data);
      toast.success("Launchpad switched — settings reset.");
    } else {
      toast.error("Error switching launchpad style");
    }
  };

  if (loader) return <>Loading...</>;

  return (
    <div>
      <style>{`
        .lp-switch {
          display: inline-flex;
          background: #f1f5f9;
          border: 1px solid #e7ebf1;
          border-radius: 13px;
          padding: 4px;
          gap: 4px;
        }
        .lp-switch-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          border: none;
          background: transparent;
          color: #64748b;
          font-size: 13.5px;
          font-weight: 600;
          padding: 8px 18px;
          border-radius: 9px;
          cursor: pointer;
          white-space: nowrap;
          transition: color .15s ease, background .15s ease, box-shadow .15s ease;
        }
        .lp-switch-btn:hover { color: #334155; }
        .lp-switch-btn.active {
          background: #ffffff;
          color: #2563eb;
          box-shadow: 0 1px 4px rgba(15,23,42,.12);
        }
        .lp-switch-btn i { font-size: 15px; }

        .lp-list {
          border: 1px solid #eef2f7;
          border-radius: 16px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 1px 2px rgba(15,23,42,.04);
        }
        .lp-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 16px 20px;
          border-bottom: 1px solid #f1f5f9;
          transition: background .12s ease;
        }
        .lp-item:last-child { border-bottom: none; }
        .lp-item:hover { background: #f8fafc; }
        .lp-item-icon {
          width: 44px;
          height: 44px;
          flex-shrink: 0;
          border-radius: 11px;
          background: #f1f5f9;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .lp-item-icon img { width: 24px; height: 24px; object-fit: contain; }
        .lp-item-body { flex: 1; min-width: 0; }
        .lp-item-title {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          margin: 0 0 2px;
          line-height: 1.45;
        }
        .lp-item-tagline {
          font-size: 12.5px;
          color: #94a3b8;
          margin: 0;
          line-height: 1.45;
        }
        .lp-item-actions { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
        .lp-action-btn {
          border: none;
          background: #38a169;
          color: #fff;
          font-weight: 600;
          font-size: 12.5px;
          padding: 9px 16px;
          border-radius: 8px;
          cursor: pointer;
          white-space: nowrap;
          transition: background .15s ease;
        }
        .lp-action-btn:hover { background: #2f855a; }
      `}</style>
      <MMStyles />
      <div className="d-flex justify-content-between align-items-center mb-4 gap-2 flex-wrap">
        <div className="lp-switch" role="tablist" aria-label="Launchpad style">
          <button
            type="button"
            role="tab"
            aria-selected={launchpadType === "old"}
            className={`lp-switch-btn ${launchpadType === "old" ? "active" : ""}`}
            onClick={() => handleToggleType("old")}
          >
            <i className="bi bi-grid-1x2"></i> Classic Launchpad
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={launchpadType === "new"}
            className={`lp-switch-btn ${launchpadType === "new" ? "active" : ""}`}
            onClick={() => handleToggleType("new")}
          >
            <i className="bi bi-rocket-takeoff"></i> Setup Guide
          </button>
        </div>
        {launchpadType === "old" && (
          <div className="d-flex gap-2">
            <AddTask
              data={data}
              handleRefresh={getData}
              defaultTasks={defaultTasks}
            />
            <button
              type="button"
              className="mm-btn mm-btn--ghost"
              onClick={handleResetDefault}
            >
              Reset to default
            </button>
          </div>
        )}
      </div>

      {launchpadType === "new" ? (
        <NewLaunchPad tasks={tasks} data={data} onRefresh={getData} />
      ) : (
      <ul className="lp-list list-unstyled mb-0">
        {tasks.map((item, index) => (
          <li className="lp-item" key={index}>
            <span className="lp-item-icon">
              <img src={item.imageUrl} alt="" />
            </span>
            <div className="lp-item-body">
              <p className="lp-item-title">{item.description}</p>
              {item.tagline ? (
                <p className="lp-item-tagline">{item.tagline}</p>
              ) : null}
            </div>
            <div className="lp-item-actions">
              <button className="lp-action-btn">{item.buttonText}</button>
              <AddTask
                data={data}
                handleRefresh={getData}
                selectedTab={item}
                editIndex={index}
                defaultTasks={defaultTasks}
              />
            </div>
          </li>
        ))}
      </ul>
      )}

      {pendingType && (
        <div className="mm-overlay" onMouseDown={() => setPendingType(null)}>
          <div
            className="mm-dialog"
            role="dialog"
            aria-modal="true"
            style={{ maxWidth: 440 }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <header className="mm-header d-flex align-items-start gap-3">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  flexShrink: 0,
                  borderRadius: "9999px",
                  background: "#fef3c7",
                  color: "#d97706",
                }}
              >
                <i className="bi bi-exclamation-triangle-fill"></i>
              </span>
              <div>
                <h5 className="mm-title mb-0">
                  Switch to{" "}
                  {pendingType === "new" ? "Setup Guide" : "Classic Launchpad"}?
                </h5>
                <p className="mm-subtitle mb-0">
                  Your current launchpad settings will be reset after switching
                  launchpad. Do you want to continue?
                </p>
              </div>
            </header>
            <footer className="mm-footer d-flex justify-content-end gap-2">
              <button
                type="button"
                className="mm-btn mm-btn--ghost"
                onClick={() => setPendingType(null)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="mm-btn mm-btn--primary"
                onClick={confirmSwitch}
              >
                Yes, switch &amp; reset
              </button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
};

export default LaunchPad;
